// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 763 ? "7795b455" : chunkId) + "-" + {"759":"e7deb7e1e369b232","763":"e98b344b09c5b417","942":"9c5b679b1ad94831"}[chunkId] + ".js";
};